import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";


export class SliderEmptyStateProps extends BaseProps {
  text: String;
  className: String
}

export const SliderEmptyState = (props: SliderEmptyStateProps) => {
  return (
    <div className={props.className}>
      {
        props.text
      }
    </div>
  )
}
